
import { useEffect } from 'react';
import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

// Settings Components
import { Label } from '../../bpl-tools/Components';
import { tabController } from '../../bpl-tools/utils/functions';

import Settings from './Settings';
import Style from './Style';
import { photosOpt } from './utils/options';
import Layout from './Layout';
import { loadingIcon } from './utils/icons';
import useWPAjax from './hooks/useWPAjax';


const Edit = (props) => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;
	const { photosType } = attributes;

	const { isLoading, data: token, refetch: fetchData } = useWPAjax('bpgpb_retrieve_access_token', { nonce: window.wpApiSettings?.nonce })

	useEffect(() => {
		clientId && setAttributes({ cId: clientId.substring(0, 10) });
	}, [clientId]);

	useEffect(() => tabController(), [isSelected]);

	useEffect(() => {
		window.addEventListener('bpgpbEventEdit', () => {
			fetchData();
		});
	}, []);

	if (isLoading) {
		return <div className='loadingIcon'>{loadingIcon} </div>
	}
	if (!token?.access_token) {
		return <div className='bpgpbSelectArea'>
			<h2>{__('Authorization and Access Token Required', 'embed-google-photos')}</h2>
			<button className='pbgpbTarget' onClick={() => {
				wp.data.dispatch('core/edit-post').openGeneralSidebar('bpgpb-google-photos/bpgpb-google-photos');
			}} >{__('Authorization', 'embed-google-photos')}</button>
		</div>
	}

	if (!photosType) {
		return <div className='bpgpbSelectArea'>
			<h2>{__('You must select photos type', 'embed-google-photos')}</h2>

			<Label className='mt0 label'>{__('Photo Type', 'embed-google-photos')}</Label>
			<SelectControl value={photosType} options={[{ label: 'Select', value: '' }, ...photosOpt]} onChange={(val) => setAttributes({ photosType: val })} />
		</div>
	}

	console.log(token);

	return (<>
		<Settings attributes={attributes} setAttributes={setAttributes} token={token} />
		<div className={className} id={`BPGPBBlockDirectory-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />
			<div className="BPGPBBlockDirectory">
				<Layout attributes={attributes} token={token} />
			</div>
		</div>
	</>
	);
};

export default Edit;